import { Info } from "lucide-react";
import { completionEstimateExplanation } from "../completion-estimate";

export function CompletionEstimateInfo() {
  return <span className="completion-estimate-info" tabIndex={0} aria-label="About this estimated completion date">
    <Info aria-hidden="true" />
    <span className="completion-explainer" role="tooltip">{completionEstimateExplanation}</span>
  </span>;
}
